import { ListContainer } from "@/components/layout/ListContainer";
import { type PrePlanningDetail } from "@repo/api";
import { useState } from "react";

import { InspirationItem } from "./InspirationItem";
import { InspirationModal } from "./InspirationModal";

interface InspirationsProps {
  inspirations?: PrePlanningDetail[];
}

export const Inspirations = ({ inspirations }: InspirationsProps) => {
  const [selectedItem, setSelectedItem] = useState<
    PrePlanningDetail | undefined
  >(undefined);

  if (!inspirations || inspirations.length === 0) {
    return null;
  }

  return (
    <>
      <ListContainer>
        {inspirations.map((item) => (
          <InspirationItem
            key={item.sourceId}
            inspiration={item}
            setSelectedItem={setSelectedItem}
          />
        ))}
      </ListContainer>
      <InspirationModal
        isOpen={selectedItem !== undefined}
        closeModal={() => setSelectedItem(undefined)}
        inspiration={selectedItem}
      />
    </>
  );
};
